import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useShiftAuth } from '../../contexts/ShiftAuthProvider';

export function useShiftHeaderController() {
  const { user, logout } = useShiftAuth();

  const navigate = useNavigate();

  const location = useLocation();

  const [openMenu, setOpenMenu] = useState(false);
  const [openNavigationMenu, setOpenNavigationMenu] = useState(false);

  const menuWrapRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    setOpenMenu(false);
    setOpenNavigationMenu(false);
  }, [location.pathname]);

  const onNavigationMenuChange = (opened: boolean) => {
    if (opened) setOpenMenu(false);
    setOpenNavigationMenu(opened);
  };
  const onToggleUserMenu = () => {
    setOpenNavigationMenu(false);
    setOpenMenu(current => !current);
  };

  useEffect(() => {
    if (!openMenu) {
      return;
    }

    const handleDocumentClick = (event: MouseEvent) => {
      const target = event.target as Node;
      if (!menuWrapRef.current?.contains(target)) {
        setOpenMenu(false);
      }
    };

    document.addEventListener('mousedown', handleDocumentClick);
    return () => {
      document.removeEventListener('mousedown', handleDocumentClick);
    };
  }, [openMenu]);

  const onLogout = async () => {
    setOpenMenu(false);
    await logout();
    navigate('/login', { replace: true });
  };

  return { user, navigate, location, openMenu, setOpenMenu, menuWrapRef, onLogout,
    openNavigationMenu, onNavigationMenuChange, onToggleUserMenu };
}
